// istanbul ignore file
/**
 * Imports SimplifiedCardModule from shared-ui
 */
import type { SimplifiedCardModuleProps } from '@makemydeal/dr-sales-checkin-types';
import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';

export const SimplifiedCardModule: FunctionComponent<SimplifiedCardModuleProps> = createRemoteModule<SimplifiedCardModuleProps>(
    'customer',
    './SimplifiedCardModule'
);
